export const linkedIn = 'https://www.linkedin.com/company/uniprot/';
export const twitterX = 'https://x.com/uniprot';
export const youtube = 'https://www.youtube.com/user/uniprotvideos';
export const blogspot = 'https://insideuniprot.blogspot.com/';
